import { render, staticRenderFns } from "./VxSidebar.vue?vue&type=template&id=fbfc0172&lang=pug&"
import script from "./VxSidebar.vue?vue&type=script&lang=js&"
export * from "./VxSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VxSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VxSidebar.vue?vue&type=style&index=1&lang=css&"
import style2 from "./VxSidebar.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports